import React from 'react'
import { useStaticDataStore } from '../../stores/staticData';
import dummyCompany from '../../assets/images/dummyCompany.png'

const VCTab = ({ startupData }) => {

    const { data: staticData } = useStaticDataStore();

    let industryTags = [];
    if (staticData?.industryTags?.length) {
        industryTags = staticData?.industryTags;
    }
    let startupStages = [];
    if (staticData?.startupStages?.length) {
        startupStages = staticData?.startupStages;
    }
    return (
        <div className='vc-edit-section'>
            <div className='vc-details'>
                <div className='vc-dummy-image'>
                    <img src={startupData?.logo || dummyCompany} alt="vc dummy image" />
                </div>
                <div className='vc-detail-section vc-company-section'>
                    <div>
                        <span className='label'>VC name</span>
                        <div className='value'>{startupData?.name}</div>
                    </div>
                    <div>
                        <span className='label'>About the VC</span>
                        <div className='value'>{startupData?.about}</div>
                    </div>
                    <div>
                        <span className='label'>Startups invested in</span>
                        <div className='value'>{startupData?.investedIn}</div>
                    </div>
                    <div>
                        <span className='label'>LinkedIn page</span>
                        <div className='value'>{startupData?.linkedInUrl}</div>
                    </div>
                    <div>
                        <span className='label'>Website</span>
                        <div className='value'>{startupData?.website}</div>
                    </div>
                    <div>
                        <span className='label'>Industries</span>
                        <div className="value">
                            {startupData?.industryTags?.map((key, idx) => {
                                const matched = industryTags?.find(item => item?.key === key);
                                return (
                                    <span key={key}>
                                        {matched?.value || key}
                                        {idx < startupData.industryTags.length - 1 ? ', ' : ''}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                    <div>
                        <span className='label'>Startup stages</span>
                        <div className="value">
                            {startupData?.startupStages?.map((key, idx) => {
                                const matched = startupStages?.find(item => item?.key === key);
                                return (
                                    <span key={key}>
                                        {matched?.value || key}
                                        {idx < startupData.startupStages.length - 1 ? ', ' : ''}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VCTab